import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

const setIsTeamsHighContrastMutator: (isTeamsHighContrast: boolean) => void = mutatorAction(
    'setIsTeamsHighContrast',
    (isTeamsHighContrast: boolean): void => {
        getStore().isTeamsHighContrast = isTeamsHighContrast;
    }
);
export default setIsTeamsHighContrastMutator;
